<template>
  <div class="mt-3">
    <b-overlay center :show="isLoading" rounded="sm">
      <div v-if="!isLoading">
        <permissions-matrix
          :modules="user_permissions.modules"
        ></permissions-matrix>
        <div class="form-actions form-actions--sticky">
          <div class="inner-wrapper">
            <div>
            </div>
            <div>
              <b-button
                @click="$router.back()"
                class="btn--transparent"
                type="button"
                title="Torna alla pagina precedente"
              >
                <b-icon-chevron-double-left
                  font-scale="0.9"
                ></b-icon-chevron-double-left
                >
                Torna indietro
              </b-button
              >
            </div>
          </div>
        </div>
      </div>
      <template #overlay>
        <div class="text-center">
          <div class="custom-loader"></div>
          <p class="loading-text">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import PermissionsMatrix from "@/components/form/permissions-matrix/PermissionsMatrix.vue";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import UserPermissionsMixin from "@/mixins/UserPermissionsMixin";

export default {
  mixins: [UserPermissionsMixin],
  components: { PermissionsMatrix },
  name: "Permissions",
  props: {
    msg: String,
  },
  data() {
    return {
      isLoading: false,
      user: this.$route.params.user,
      repository: "user",
      user_permissions: { modules: [] },
    };
  },
  mounted() {
    this.isLoading = true;
    //Fetch user permissions
    const Repo = RepositoryFactory.get(this.repository);
    Repo.show_permissions(this.user.id)
      .then((response) => {
        const data = response.data.data;

        this.user_permissions = this.groupByModule(data);
        const allModules = Array.from(this.user_permissions.modules);
        this.user_permissions.modules.splice(0, allModules.length);
        this.user_permissions.modules = allModules.filter((object) => {
          return (
            object.name !== "Servizio LISA4APP" &&
            object.name !== "Priv-Easy" &&
            object.name !== "Profilo"
          );
        });
        this.isLoading = false;
      })
      .catch((error) => {
        let errMsg = this.$getErrorMessage(error);
        this.$showSnackbar({
          preset: "error",
          text: `${errMsg}`,
        });
        this.isLoading = false;
      });
  },
};
</script>
